export enum TaskAction {
    ASSIGN_BUDGET_OWNERS = 'ASSIGN_BUDGET_OWNERS',
    COMPLETE_BUDGET = 'COMPLETE_BUDGET',
    BUDGET_CHANGE_REQUEST = 'BUDGET_CHANGE_REQUEST',
    BUDGET_APPROVAL = 'BUDGET_APPROVAL',
}
